import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faHeart } from '@fortawesome/free-solid-svg-icons';
import DoarModal from './DoarModal';

const navLinks = [
  { href: '#home', label: 'Início' },
  { href: '#about', label: 'Sobre' },
  { href: '#lideranca', label: 'Liderança' },
  { href: '#schedules', label: 'Cultos' },
  { href: '#gcs', label: 'GCs' },
  { href: '#wecare', label: 'WeCare' },
  { href: '#sermons', label: 'Mensagens' },
  { href: '#contact', label: 'Contato' },
];

const Header = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const [isDoarOpen, setIsDoarOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#0a0f1e]/90 backdrop-blur-md shadow-xl shadow-black/30 border-b border-white/5'
          : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">
            <a href="#home" className="flex-shrink-0 flex items-center">
              <img
                src="/images/64382eb8c029a.png"
                alt="Logo Igreja Lagoinha"
                className="h-14 w-14 rounded-full object-cover ring-2 ring-yellow-500/30"
              />
            </a>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-gray-300 hover:text-white focus:outline-none p-2"
              aria-label="Abrir menu"
            >
              <FontAwesomeIcon icon={faBars} className="text-xl" />
            </button>

            <div className="hidden md:flex items-center gap-1">
              {navLinks.map(({ href, label }) => (
                <a
                  key={href}
                  href={href}
                  className="nav-link-underline relative text-gray-400 hover:text-white px-3.5 py-2 text-sm font-medium transition-colors"
                >
                  {label}
                </a>
              ))}

              <div className="flex items-center gap-2 ml-3">
                <a
                  href="https://forms.clickup.com/9011854024/f/8cjbyp8-1191/TDTGOG3V0CF5K6PAOG"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-500 px-4 py-2 rounded-lg transition-all duration-200"
                >
                  Sou Visitante
                </a>
                <button
                  onClick={() => setIsDoarOpen(true)}
                  className="flex items-center gap-1.5 text-sm font-bold text-gray-900 bg-yellow-500 hover:bg-yellow-400 px-4 py-2 rounded-lg transition-all duration-200 shadow-md shadow-yellow-500/20"
                >
                  Ofertar <FontAwesomeIcon icon={faHeart} className="text-xs" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <DoarModal isOpen={isDoarOpen} onClose={() => setIsDoarOpen(false)} />
    </>
  );
};

export default Header;
